import { createDeepEqualSelector } from "../utils/createDeepEqualSelector";

import type { RootState } from "../store";

const selectFromState = (state: RootState) => state.swiftwireTemplates.byId;

/**
 * Sort templates by last_used descending (most recently used first).
 * Templates with no last_used date are pushed to the end.
 */
const sortByLastUsed = (a: API.SwiftWireTemplate, b: API.SwiftWireTemplate) => {
  if (!a.last_used) return 1;
  if (!b.last_used) return -1;
  return Date.parse(b.last_used) - Date.parse(a.last_used);
};

export const selectSwiftWireTemplates = createDeepEqualSelector(
  selectFromState,
  (byId) => Object.values(byId),
);

export const selectOneSwiftWireTemplate = createDeepEqualSelector(
  [
    selectFromState,
    (_, swiftWireTemplateId?: API.SwiftWireTemplateId) => swiftWireTemplateId,
  ],
  (byId, swiftWireTemplateId) => {
    return swiftWireTemplateId ? byId[swiftWireTemplateId] : undefined;
  },
);

export const selectSortedSwiftWireTemplateIds = createDeepEqualSelector(
  [selectSwiftWireTemplates],
  (templates) => {
    return [...templates].sort(sortByLastUsed).map((t) => t.id);
  },
);

/**
 * Returns sorted template IDs filtered by recipient currency.
 * Includes templates where recipient_currency matches the given currency
 * OR where recipient_currency is not set (null/undefined).
 */
export const selectSwiftWireTemplateIdsByCurrency = createDeepEqualSelector(
  [selectSwiftWireTemplates, (_, currency?: string) => currency],
  (templates, currency) => {
    return templates
      .filter((t) => !t.recipient_currency || t.recipient_currency === currency)
      .sort(sortByLastUsed)
      .map((t) => t.id);
  },
);
